const ORG_NAME_TOKEN_REGEX = /\{org_name\}/g

export const applyOrganizationNamePlaceholder = (
  text: string,
  organizationName: string | null | undefined
): string => (organizationName ? text.replace(ORG_NAME_TOKEN_REGEX, organizationName) : text)
